var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResumeDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "250px",
    height: "325px",
    viewBox: "0 0 250 325",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "placeholder-resume copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "placeholder-resume-copy-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 250,
    height: 325
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 20.000000)",
    fillRule: "nonzero",
    stroke: "#CCCCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,1.5 L75.5,1.5",
    id: "Line-Copy-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,11.25 L211,11.25",
    id: "Line-Copy-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,20.2083333 L182,20.2083333",
    id: "Line-Copy-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,67.9166667 L211,67.9166667",
    id: "Line-Copy-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4265403,87.8333333 L211,87.8333333",
    id: "Line-Copy-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,76.875 L211,76.875",
    id: "Line-Copy-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4265403,97.8333333 L178,97.8333333",
    id: "Line-Copy-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4265403,107.972222 L200,107.972222",
    id: "Line-Copy-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,40.2083333 L98,40.2083333",
    id: "Line-Copy-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,58.2013889 L20,58.2013889",
    id: "Line-Copy-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5,58.2002315 L44,58.2002315",
    id: "Line-Copy-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,146.583333 L211,146.583333",
    id: "Line-Copy-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4265403,167.208333 L211,167.208333",
    id: "Line-Copy-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,155.541667 L211,155.541667",
    id: "Line-Copy-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4265403,177.166667 L200,177.166667",
    id: "Line-Copy-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4265403,195.638889 L200,195.638889",
    id: "Line-Copy-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4265403,186.305556 L163,186.305556",
    id: "Line-Copy-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,136.534722 L43,136.534722",
    id: "Line-Copy-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,243.25 L18,243.25",
    id: "Line-Copy-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,243.208333 L42,243.208333",
    id: "Line-Copy-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4265403,262.833333 L203,262.833333",
    id: "Line-Copy-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,252.208333 L211,252.208333",
    id: "Line-Copy-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4265403,273.833333 L178,273.833333",
    id: "Line-Copy-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4265403,284.305556 L200,284.305556",
    id: "Line-Copy-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,216.208333 L98,216.208333",
    id: "Line-Copy-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,233.201389 L43,233.201389",
    id: "Line-Copy-34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(45.000000, 107.000000)",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    cx: 1.5,
    cy: 1,
    rx: 1.5,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy",
    cx: 1.5,
    cy: 11,
    rx: 1.5,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-2",
    cx: 1.5,
    cy: 21,
    rx: 1.5,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(45.000000, 186.000000)",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    cx: 1.5,
    cy: 1,
    rx: 1.5,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy",
    cx: 1.5,
    cy: 11,
    rx: 1.5,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-2",
    cx: 1.5,
    cy: 20,
    rx: 1.5,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(45.000000, 282.000000)",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    cx: 1.5,
    cy: 1,
    rx: 1.5,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy",
    cx: 1.5,
    cy: 12,
    rx: 1.5,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-2",
    cx: 1.5,
    cy: 22,
    rx: 1.5,
    ry: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeDefault);
export default __webpack_public_path__ + "static/media/resume-default.2a714250b6df011e1dd78fe2a2c52f55.svg";
export { ForwardRef as ReactComponent };